import React, { useState, useEffect } from "react";
import { sendSignInLinkToEmail, isSignInWithEmailLink, signInWithEmailLink } from "firebase/auth";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { useAuth } from "../context/AuthContext";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/navbar";
import data from "../data/data.json";

// Firebase configuration
const actionCodeSettings = {
  url: window.location.href,
  handleCodeInApp: true,
};


const Signup = () => {
  const navigate = useNavigate();
  const { isLoggedIn, checkUserExists } = useAuth();
  const [email, setEmail] = useState("");
  const [fullname, setFullname] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {

    // check if the user is logged in
    if (isLoggedIn) { navigate("/my-account"); }

    // Handle login from email link
    const checkEmailLink = async () => {
      if (isSignInWithEmailLink(auth, window.location.href)) {

        let emailForLink = window.localStorage.getItem("emailForLink");

        if (!emailForLink) {
          emailForLink = window.prompt(data.auth.pleaseProvideEmail);
        }

        try {
          signInWithEmailLink(auth, emailForLink, window.location.href)
            .then((result) => {
              checkUserExists(result.user.uid);
              navigate("/my-account");
            })
            .catch((error) => {
              console.log("error", error);
            });
        } catch (err) {
          setError(err.message);
        }
      }
    };
    checkEmailLink();

    return () => {
      // Cleanup if needed
    }
  }, [isLoggedIn, navigate, checkUserExists]);

  const handleSendLink = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    try {
      await sendSignInLinkToEmail(auth, email, actionCodeSettings);
      window.localStorage.setItem("emailForLink", email);
      setMessage(data.auth.loginLinkSent);
    } catch (err) {
      setError(err.message);
    }
  }

  const handleGoogleSignUp = async () => {
    setError("");
    setMessage("");
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);

      // Check if user already exists in Firestore and create a new user if not
      await checkUserExists(result.user.uid);

      navigate("/my-account");
    } catch (err) {
      setError(err.message);
    }
  };


  return (
    <>
      <Navbar page="signup" />
      <section className="w-full bg-pf-bgDarker relative h-[100vh] flex flex-col items-center justify-center">
        <div className="bg-white rounded-3xl shadow-2xl w-full max-w-5xl flex flex-col items-center justify-center px-10 py-20">
          <div className="w-full flex md:flex-row flex-col items-center justify-center md:space-x-20">
            <div className="w-full md:w-1/2 flex flex-col items-center justify-center">
              <h2 className="text-3xl font-bold mb-6 text-pf-titleDark text-center">{data.auth.signupTitle}</h2>
              <p className="text-gray-600 text-lg text-left">
                {data.auth.signupSubtitle}
              </p>
              <p className="text-gray-600 text-lg text-left">
                {data.auth.signupSubtitle2}
              </p>
            </div>
            <div className="w-full md:w-1/2 flex flex-col items-center justify-center">
              {error && <p className="text-red-500 text-sm mb-4">{error}</p>}
              {message && <p className="text-green-600 text-sm mb-4">{message}</p>}
              <form onSubmit={handleSendLink} className="w-full space-y-6">
                <div className="w-full">
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                    placeholder={data.auth.emailPlaceholder}
                    required
                  />
                  <input
                    type="text"
                    value={fullname}
                    onChange={(e) => setFullname(e.target.value)}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg my-4"
                    placeholder={data.auth.namePlaceholder}
                  />
                </div>
                <button
                  type="submit"
                  className="w-full bg-green-600 text-white py-3 rounded-full font-bold"
                >
                  {data.auth.signupButtonEmailLabel}
                </button>
              </form>
              <div className="w-full mt-6">
                <button
                  type="button"
                  onClick={handleGoogleSignUp}
                  className="w-full bg-red-500 hover:bg-red-600 text-white py-3 rounded-full font-bold"
                >
                  {data.auth.signupButtonGoogleLabel}
                </button>
              </div>
              <div className="mt-4 text-center">
                <p className="text-gray-600 text-sm">
                  {data.auth.alreadyHaveAccount}{" "}
                  <a href="/login" className="text-green-700 font-bold">
                    {data.auth.loginHere}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Signup;
